import type { ReactNode } from "react";

/**
 * Writes a number with thousands separators. A whole number has no decimals; a
 * number with a fraction has `decimals` of them (2 unless the currency says
 * otherwise: a Jordanian dinar is written with 3, `100.125`).
 */
export function formatNumber(num: number, sign?: ReactNode, decimals = 2) {
  const hasFraction = num % 1 !== 0;
  const formatted = Number(num).toLocaleString("en-US", {
    minimumFractionDigits: hasFraction ? decimals : 0,
    maximumFractionDigits: hasFraction ? decimals : 0,
  });

  return sign ? (
    <span className="flex items-center gap-1">
      <span>{sign}</span>
      <span>{formatted}</span>
    </span>
  ) : (
    formatted
  );
}

/** Writes an amount with exactly `decimals` decimals (2 unless the currency says otherwise). */
export function formatCurrencyNumber(num: number, decimals = 2) {
  return Number(num).toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export const formatValue = (
  value: number | null | undefined,
  isMonetary = false,
  decimals = 2
) => {
  if (value === null || value === undefined) return "—";

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: isMonetary ? decimals : 0,
  }).format(value);
};
